import { ACTIONS } from './action.js';

export function answerActionReducer(state, action) {

  switch (action.type) {

      case ACTIONS.FETCH:
        return action.payload;
      case ACTIONS.EDIT:
        return {...state, ...action.payload}
      default:
        return state;
  }
}

export function attachmentsReducer(state, action) {

  switch (action.type) {
    case ACTIONS.FETCH:
      return action.payload;
    case ACTIONS.CREATE:
      return [...state, action.payload];
    case ACTIONS.DELETE:
      return state.filter(attachment => attachment.ANSWER_ACTION_ATTACHMENT_ID !== action.payload);
  }
}